import React, { useState } from "react";
import AuthContainer from "../../../components/AuthContainer.js";
import BackButton from "../../../components/BackButton/index.js";
import { Box, Container, Typography } from "@mui/material";
import ReactCodeInput from "react-code-input";
import appcolors from "../../../constants/Colors.js";
import { useLocation, useNavigate } from "react-router-dom";
import Label from "./../../../components/Label/index";
import GlobalButton from "../../../components/CustomButton/index.js";
import { createBusinessAccount } from "../../../services/Auth.js";
import Loader from "../../../components/Loader/index.js";
import SnackbarAlert from "../../../components/SnackBar/index.js";
import { setUser } from "../../../lib/slices/userSlice.js";
import { useDispatch } from "react-redux";

const props = {
  inputStyle: {
    fontFamily: "Inter",
    // margin: "10px",
    MozAppearance: "textfield",
    width: "40px",
    borderRadius: "2px",
    fontSize: "14px",
    height: "45px",
    textAlign: "center",
    color: appcolors.black,
    border: `1px solid ${appcolors.slateGrey}`,
  },
};

function Signupverification() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [code, setCode] = useState("");
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };
  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleVerifyOtp = async () => {
    try {
      let payload = {
        firstname: state?.firstName,
        lastname: state?.lastName,
        email: state?.email,
        contactNumber: state?.contactNumber,
        password: state?.password,
        role: "business",
        inputOtp: code,
        status: true,
      };
      setIsLoading(true);
      const responce = await createBusinessAccount(payload);
      setIsLoading(false);
      if (responce.status == 200 || responce.status == 201) {
        localStorage.setItem("user-data", JSON.stringify(responce?.data?.data));
        dispatch(setUser(responce?.data?.data));
        handleSnackbarVal(true, "success", responce?.data?.message);
        setTimeout(() => {
          navigate("/sign-up/steps");
        }, 1000);
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      handleSnackbarVal(true, "error", error?.data?.message);
    }
  };
  return (
    <AuthContainer>
      <BackButton />
      <Container sx={{ maxWidth: "520px !important", mt: 6 }}>
        <Typography variant="auth_h1" component={"h1"}>
          Verification process
        </Typography>
        <Typography variant="auth_body1" component={"p"} sx={{ mt: 0.5 }}>
          We send it the 6 digit code on your company email address please enter
          the code
        </Typography>
        <Container maxWidth="xs">
          <Box
            sx={{ margin: { xs: "2rem 0", md: "3rem 0" } }}
            className={"react-cvi"}
          >
            <Label labelText="Enter 6 digit code" />
            <ReactCodeInput
              type="number"
              value={code}
              onChange={(e) => {
                setCode(e);
              }}
              fields={6}
              {...props}
            />
          </Box>
          <Box mt={5}>
            <GlobalButton
              variant={"contained"}
              btnText={"Next"}
              handleClickBtn={handleVerifyOtp}
            />
          </Box>
        </Container>
      </Container>
      <Loader isLoading={isLoading} />
      <SnackbarAlert
        handleCloseSnackbar={handleCloseSnackbar}
        snackbarProps={snackbarProps}
      />
    </AuthContainer>
  );
}

export default Signupverification;
